/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pol_Table_ScrollInputs */

const en_pol_table_scroll = /** @type {(inputs: Pol_Table_ScrollInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scroll the table sideways to see every column.`)
};

const id_pol_table_scroll = /** @type {(inputs: Pol_Table_ScrollInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geser tabel ke samping untuk melihat semua kolom.`)
};

/**
* | output |
* | --- |
* | "Scroll the table sideways to see every column." |
*
* @param {Pol_Table_ScrollInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const pol_table_scroll = /** @type {((inputs?: Pol_Table_ScrollInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pol_Table_ScrollInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_pol_table_scroll(inputs)
	return en_pol_table_scroll(inputs)
});